
import * as React from 'react';
import { IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { FileIconType, IFileTypeIconOptions } from '@uifabric/file-type-icons/lib/index';
import { FileTypeIcon } from '../../../components/itemFileTypeIcon/ItemFileTypeIcon';
import * as FileTypeIconFieldStyles from './FileTypeIconField.scss';

/**
 * @public
 * @deprecated Use ItemFileTypeIcon or fileTypeIconColumn directly.
 */
export interface IFileTypeIconFieldProps {
  extension: string | undefined;
  isFolder: boolean | undefined;
  isOneNote: boolean | undefined;
  fileIconType: FileIconType | undefined;
  column?: IColumn;
}

/**
 * @public
 * @deprecated Use ItemFileTypeIcon or fileTypeIconColumn directly.
 */
export const FileTypeIconField: React.StatelessComponent<IFileTypeIconFieldProps> = (props: IFileTypeIconFieldProps) => {
  const {
    column,
    extension,
    fileIconType,
    isFolder,
    isOneNote
  } = props;

  const width = column && column.currentWidth;

  let size: IFileTypeIconOptions['size'];

  if (typeof width === 'number') {
    if (width >= 96) {
      size = 96;
    } else if (width >= 48) {
      size = 48;
    } else if (width >= 40) {
      size = 40;
    } else if (width >= 32) {
      size = 32;
    } else if (width >= 20) {
      size = 20;
    } else {
      size = 16;
    }
  } else {
    size = 16;
  }

  return (
    <FileTypeIcon
      className={ FileTypeIconFieldStyles.icon }
      extension={ extension }
      size={ size }
      isOneNote={ isOneNote }
      isFolder={ isFolder }
      type={ fileIconType }
    />
  );
};
